import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useParams, useHistory } from "react-router-dom"
import { useAppContext } from "components/AppContext"

// Themes excluded from Explore (no dashboard available yet)
const EXCLUDED_THEMES = [
  "csr", // CSR analytics - not yet implemented
  "websites", // Not yet implemented, commit on websites dates from 20/01/2026 and is Fake website explore
]

export const useAnalyticsTabs = (envScore) => {
  const { currentRootNode } = useAppContext()
  const { themeId } = useParams()
  const { t } = useTranslation()
  const history = useHistory()

  const tabs = useMemo(() => {
    const tabsConfig = [
      {
        name: t(`analytics:tabs.workplace`),
        hidden:
          EXCLUDED_THEMES.includes("workplace") ||
          !envScore?.odd13_workplace_CO2 ||
          +envScore?.odd13_workplace_CO2 === 0,
        selected: themeId === "workplace",
        url: "/explore/environmental/13/workplace",
        co2e: envScore?.odd13_workplace_CO2 || 0,
      },
      {
        name: t("analytics:tabs.network"),
        hidden:
          EXCLUDED_THEMES.includes("network") ||
          !envScore?.odd13_network_equipment_CO2 ||
          +envScore?.odd13_network_equipment_CO2 === 0,
        selected: themeId === "network",
        url: "/explore/environmental/13/network",
        co2e: envScore?.odd13_network_equipment_CO2 || 0,
      },
      {
        name: t("analytics:tabs.infrastructure"),
        hidden:
          EXCLUDED_THEMES.includes("infrastructure") ||
          !envScore?.odd13_datacenter_internal_CO2 ||
          +envScore?.odd13_datacenter_internal_CO2 === 0,
        selected: themeId === "infrastructure",
        url: "/explore/environmental/13/infrastructure",
        co2e: envScore?.odd13_datacenter_internal_CO2 || 0,
      },
      {
        name: t("analytics:tabs.websites"),
        hidden:
          EXCLUDED_THEMES.includes("websites") ||
          !envScore?.website_analyse?.number_of_websites ||
          envScore?.website_analyse?.number_of_websites === 0,
        selected: themeId === "websites",
        url: "/explore/environmental/13/websites",
        co2e: envScore?.odd13_software_CO2_websites || 0,
      },
      {
        name: t("analytics:tabs.inventory"),
        hidden:
          EXCLUDED_THEMES.includes("inventory") ||
          !envScore?.has_equipment_inventories,
        selected: themeId === "inventory",
        url: "/explore/environmental/13/inventory",
        co2e:
          envScore?.odd13_workplace_CO2 +
            envScore?.odd13_datacenter_CO2_equipments +
            envScore?.odd13_network_equipment_CO2 || 0,
      },
      {
        name: t("analytics:tabs.csrd"),
        hidden:
          EXCLUDED_THEMES.includes("csrd") ||
          currentRootNode?.id == 2907 ||
          currentRootNode?.id == 2775 ||
          currentRootNode?.is_provider,
        selected: themeId === "csrd",
        url: "/explore/environmental/13/csrd",
        co2e: 0,
      },
      // {
      //   name: t("analytics:tabs.csr"),
      //   hidden: EXCLUDED_THEMES.includes("csr") || true,
      //   selected: themeId === "csr",
      //   url: "/explore/environmental/13/csr",
      //   co2e: 0,
      // },
    ].sort((a, b) => b.co2e - a.co2e)

    return tabsConfig
  }, [t, themeId, envScore])

  const redirectIfNoAvailableTab = (
    isEnvScoreLoading,
    isCurrentNodeLoading
  ) => {
    const currentTabAvailable = !!tabs.find(
      (tab) => tab.selected && !tab.hidden
    )
    if (
      !currentTabAvailable &&
      !(isEnvScoreLoading || isCurrentNodeLoading || !envScore)
    ) {
      const availableTab = tabs.find((tab) => !tab.hidden)
      if (availableTab) {
        history.push(availableTab.url)
      }
    }
  }

  return {
    tabs,
    redirectIfNoAvailableTab,
  }
}
